const options = [
    {
        index: 1,
        label: "Components",
        options: [
            {
                index: 1,
                key: "home",
                label: "Home",
                path: "/",
                isHome: true,
                icon: "home",
            },
            { index: 2, key: "button", label: "Button", path: "/button", icon: "calendar" },
            {
                index: 3,
                key: "input",
                label: "Input",
                path: "/input",
                icon: "input",
            },
        ],
    },
    {
        index: 2,
        label: "Layouts",
        options: [
            { index: 1, key: "card", label: "Card", path: "/card", icon: "customers" },
            { index: 2, key: "nav", label: "Nav", path: "/nav", icon: "visitors" },
        ],
    },
];

export default options;
